import { BasePostRequest } from './core/basePostRequest';
import * as t from 'io-ts';
import { Authentication } from './core/baseRequest';

export class PasswordCreateRequest extends BasePostRequest<undefined> {
    constructor(
        public username: string,
        public resetToken: string,
        public password: string,
        public isLoyaltySchemeOnly: boolean = false) {
        super('users/password-create',
            {}, {
                username,
                resetToken,
                password,
            }, t.undefined, Authentication.None);
    }
}
